"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionAbstractSchema = exports.IComponentFunctionChildBusSchema = void 0;
const zod_1 = require("zod");
const ComponentFunctionBusRole_1 = require("./ComponentFunctionBusRole");
const IComponentFunctionSignalBase_1 = require("./IComponentFunctionSignalBase");
const IComponentFunctionBoundary_1 = require("./IComponentFunctionBoundary");
const IFunctionCondition_1 = require("./IFunctionCondition");
const IComponentFunctionClassParameters_1 = require("./IComponentFunctionClassParameters");
exports.IComponentFunctionChildBusSchema = zod_1.z.object({
    name: zod_1.z.string(),
    childFunctionClass: zod_1.z.string(),
    classParameters: IComponentFunctionClassParameters_1.IComponentFunctionClassParametersSchema.optional(),
});
exports.IComponentFunctionAbstractSchema = zod_1.z.object({
    name: zod_1.z.string(),
    functionClass: zod_1.z.string().optional(),
    busRole: zod_1.z.nativeEnum(ComponentFunctionBusRole_1.ComponentFunctionBusRole).optional(),
    mustBeAssigned: zod_1.z.boolean().optional(),
    classParameters: IComponentFunctionClassParameters_1.IComponentFunctionClassParametersSchema.optional(),
    conditions: zod_1.z
        .lazy(() => IFunctionCondition_1.IFunctionConditionSchema)
        .array()
        .optional(),
    functionSignals: zod_1.z.lazy(() => IComponentFunctionSignalBase_1.IComponentFunctionSignalBaseSchema).array(),
    resourceConsumed: zod_1.z.string().optional(),
    boundaries: zod_1.z
        .lazy(() => IComponentFunctionBoundary_1.IComponentFunctionBoundarySchema)
        .array()
        .optional(),
    childBuses: exports.IComponentFunctionChildBusSchema.array().optional(),
});
//# sourceMappingURL=IComponentFunctionAbstract.js.map